import DesImportDataViewModel from 'viewmodel/DesImportDataViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';
import { DesAccConstants } from '../constant/desAccConstants';
const STAGING_AREA_TYPE = 'nx2tc';
export default class DesImportData extends DesBaseCollabAcc {

    constructor() {
        super(DesImportDataViewModel);
    }

    getProps() {
        return {
            accsessionid: this.accSessionId,
            collaborationspaceid: this.collaborationspaceId,
            containerid: this.stagingareatype === STAGING_AREA_TYPE ? DesAccConstants.ME : this.containerId,
            containertype: this.stagingareatype === STAGING_AREA_TYPE ? DesAccConstants.HOME : this.containerType,
            folderid: this.folderId,
            stagingareatype: this.stagingAreaType
        };
    }

    get accSessionId() {
        return this.getAttribute(DesAccConstants.ACC_SESSION_ID);
    }

    get collaborationspaceId() {
        return this.getAttribute(DesAccConstants.COLLABORATION_SPACE_ID);
    }

    get containerId() {
        return this.getAttribute(DesAccConstants.CONTAINER_ID);
    }

    get containerType() {
        return this.getAttribute(DesAccConstants.CONTAINER_TYPE);
    }

    get folderId() {
        return this.getAttribute(DesAccConstants.FOLDER_ID);
    }

    get stagingAreaType() {
        return this.getAttribute(DesAccConstants.STAGING_AREA_TYPE);
    }

    static get observedAttributes() {
        return [
            DesAccConstants.ACC_SESSION_ID, DesAccConstants.LOCALE, DesAccConstants.COLLABORATION_SPACE_ID,
            DesAccConstants.CONTAINER_ID, DesAccConstants.CONTAINER_TYPE, DesAccConstants.FOLDER_ID,
            DesAccConstants.STAGING_AREA_TYPE, DesAccConstants.AUTO_CLOSE
        ];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === DesAccConstants.STAGING_AREA_TYPE && newValue === STAGING_AREA_TYPE) {
            this.setAttribute(DesAccConstants.CONTAINER_ID, DesAccConstants.ME);
            this.setAttribute(DesAccConstants.CONTAINER_TYPE, DesAccConstants.HOME);
        }
        this.debounceCreateElement();
    }
}

if (!window.customElements.get('des-import-data')) {
    window.customElements.define('des-import-data', DesImportData);
}
